import { render, staticRenderFns } from "./CarBrandSelectbox.vue?vue&type=template&id=78834d06"
import script from "./CarBrandSelectbox.vue?vue&type=script&lang=js"
export * from "./CarBrandSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports